import { render } from "./NoticeModals.vue?vue&type=template&id=00b37e80&scoped=true"
import script from "./NoticeModals.vue?vue&type=script&lang=js"
export * from "./NoticeModals.vue?vue&type=script&lang=js"

import "./NoticeModals.vue?vue&type=style&index=0&id=00b37e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b37e80"]])

export default __exports__